import { type BadgeProps, type IconProps } from '@stone-payments/jade'

export enum ProfileMenuGroup {
  ACCOUNT_SETTINGS = 'Configurações da conta',
  ACCESS_SECURITY = 'Acesso e segurança',
  COMMERCIAL_CONDITIONS = 'Condições comerciais',
  ONLINE_SALES = 'Vendas online',
  SALES_TEST_ENVIRONMENT = 'Ambiente de testes',
  OTHERS = 'Outros'
}

export type MenuItem = {
  order: number
  label: string
  icon: IconProps['use']
  show?: boolean
  onClick?: () => void
  path?: string
  active?: (route: string) => void
  isLocked?: () => boolean
  isNew?: boolean
  badge?: { label: string; voice: BadgeProps['voice'] }
  group?: ProfileMenuGroup
}
